import { INVOICE_STATUSES, InvoiceStatus } from './enums.js';
/** The stages the invoice list is filtered by: a queue, not a single status. */
export const INVOICE_VIEWS = [
    'ALL',
    'REVIEW',
    'PENDING_APPROVAL',
    'ACCOUNTING',
    'TREASURY',
    'APPROVED',
    'PAYMENT_PENDING',
    'PAID',
    'OVERDUE',
];
/** The statuses each stage gathers. `ALL` and `OVERDUE` are not status lists. */
export const INVOICE_VIEW_STATUSES = {
    REVIEW: [InvoiceStatus.REVIEW_REQUIRED, InvoiceStatus.FAILED],
    PENDING_APPROVAL: [InvoiceStatus.PENDING_APPROVAL],
    ACCOUNTING: [InvoiceStatus.ACCOUNTING_VERIFICATION],
    TREASURY: [InvoiceStatus.TREASURY_APPROVAL],
    APPROVED: [InvoiceStatus.APPROVED],
    PAYMENT_PENDING: [
        InvoiceStatus.PAYMENT_PENDING,
        InvoiceStatus.PAYMENT_BATCHED,
        InvoiceStatus.PAYMENT_PROCESSING,
    ],
    PAID: [InvoiceStatus.PAID, InvoiceStatus.RECONCILED, InvoiceStatus.SETTLED_BY_ADVANCE],
};
/** Settled or closed: an invoice in one of these cannot be overdue. */
export const INVOICE_NOT_OVERDUE_STATUSES = [
    InvoiceStatus.PAID,
    InvoiceStatus.RECONCILED,
    InvoiceStatus.SETTLED_BY_ADVANCE,
    InvoiceStatus.CANCELLED,
    InvoiceStatus.REJECTED,
    InvoiceStatus.DUPLICATE,
];
/**
 * Statuses an invoice only passes through within one request, so it is never
 * found resting in them: offering them as a filter would always come back
 * empty. VALIDATED and SUBMITTED happen inside the submit handler; PAID moves
 * straight on to RECONCILED when the payment is settled.
 */
const PASS_THROUGH_STATUSES = new Set([
    InvoiceStatus.VALIDATED,
    InvoiceStatus.SUBMITTED,
    InvoiceStatus.PAID,
]);
/**
 * The exact statuses worth offering under a stage, in lifecycle order: only
 * those the stage can contain, and none an invoice never rests in.
 */
export function invoiceStatusOptions(view) {
    const resting = INVOICE_STATUSES.filter((status) => !PASS_THROUGH_STATUSES.has(status));
    if (!view || view === 'ALL')
        return resting;
    if (view === 'OVERDUE') {
        return resting.filter((status) => !INVOICE_NOT_OVERDUE_STATUSES.includes(status));
    }
    const inStage = INVOICE_VIEW_STATUSES[view] ?? [];
    return resting.filter((status) => inStage.includes(status));
}
//# sourceMappingURL=invoiceViews.js.map